import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
}
const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-paper bg-burnt hover:bg-terracotta-dark rounded-full shadow-[0_8px_20px_-8px_rgba(138,74,43,0.5)] transition-[background-color,transform,box-shadow] duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta-dark focus-visible:ring-offset-2 focus-visible:ring-offset-cream';
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  onLinkClick,
  ...props
}: ButtonProps) {
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.15,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-46" data-mp="30rifbxoerz5m">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.15,
    ease: [0.23, 1, 0.32, 1]
  }} {...props} data-id="element-47" data-mp="89yrlgixs7rw">
      {children}
    </motion.button>;
}